import React from 'react';
import { Field, useFormikContext } from 'formik';

interface DateTimePickerProps {
  day: any;
  index: number;
}

const DateTimePicker: React.FC<DateTimePickerProps> = ({ day, index }) => {
  const { setFieldValue, values } = useFormikContext<any>();

  const validateFromTime = (value: any) => {
    const fromTime = value;
    const toTime = values.workingHours[index]?.toTime;
    const isAvailable = values.workingHours[index]?.isAvailable;

    if (isAvailable && fromTime && toTime && fromTime >= toTime) {
      return 'From time must be less than To time';
    }
    return undefined;
  };

  const validateToTime = (value: any) => {
    const toTime = value;
    const fromTime = values.workingHours[index]?.fromTime;
    const isAvailable = values.workingHours[index]?.isAvailable;

    if (isAvailable && fromTime && toTime && fromTime >= toTime) {
      return 'To time must be greater than From time';
    }
    return undefined;
  };
  return (
    <div className="border rounded-lg shadow-md p-3 sm:p-4 bg-white w-full min-w-0 flex flex-col">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-3 sm:mb-4 gap-2">
        <div className="flex items-center min-w-0">
          <span className="text-blue-500 mr-2 flex-shrink-0">⏰</span>
          <h3 className="text-base sm:text-lg font-semibold text-gray-800 truncate">
            {['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][day]}
          </h3>
        </div>
        <div className="flex items-center justify-end sm:justify-start flex-shrink-0">
          <label className="relative inline-flex items-center cursor-pointer">
            <Field
              type="checkbox"
              name={`workingHours[${index}].isAvailable`}
              className="sr-only peer"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setFieldValue(`workingHours[${index}].isAvailable`, e.target.checked);
              }}
            />
            <div
              className={`w-11 h-6 rounded-full peer transition-colors ${values.workingHours[index].isAvailable ? 'bg-blue-600' : 'bg-gray-200'
                }`}
            >
              <div
                className={`bg-white w-5 h-5 rounded-full shadow-md transform transition-transform ${values.workingHours[index].isAvailable ? 'translate-x-5' : 'translate-x-1'
                  } mt-0.5 ml-0.5`}
              ></div>
            </div>
          </label>
        </div>
      </div>

      {/* Time Selectors */}
      <div className="space-y-3 sm:space-y-4">
        {/* From Time Selector */}
        <div>
          <label className="block text-xs sm:text-sm text-gray-600 mb-1">From</label>
          <div className="relative">
            <Field
              name={`workingHours[${index}].fromTime`}
              validate={validateFromTime}
            >
              {({ field, meta }: any) => (
                <div className="relative">
                  <input
                    type="time"
                    {...field}
                    disabled={!values.workingHours[index].isAvailable}
                    className={`block w-full p-2 text-sm border rounded-lg text-gray-800 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none disabled:bg-gray-100 disabled:cursor-not-allowed ${meta.touched && meta.error ? 'border-red-500' : 'border-gray-300'
                      }`}
                  />
                  <div className="h-6 mt-1">
                    {meta.touched && meta.error && (
                      <div className="text-red-500 text-xs absolute">{meta.error}</div>
                    )}
                  </div>
                </div>
              )}
            </Field>
          </div>
        </div>

        {/* To Time Selector */}
        <div>
          <label className="block text-xs sm:text-sm text-gray-600 mb-1">To</label>
          <div className="relative">
            <Field
              name={`workingHours[${index}].toTime`}
              validate={validateToTime}
            >
              {({ field, meta }: any) => (
                <div className="relative">
                  <input
                    type="time"
                    {...field}
                    disabled={!values.workingHours[index].isAvailable}
                    className={`block w-full p-2 text-sm border rounded-lg text-gray-800 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none disabled:bg-gray-100 disabled:cursor-not-allowed ${meta.touched && meta.error ? 'border-red-500' : 'border-gray-300'
                      }`}
                  />
                  <div className="h-6 mt-1">
                    {meta.touched && meta.error && (
                      <div className="text-red-500 text-xs absolute">{meta.error}</div>
                    )}
                  </div>
                </div>
              )}
            </Field>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DateTimePicker;